import { render, staticRenderFns } from "./ComboUsarioResponsavel.vue?vue&type=template&id=34ea454f"
import script from "./ComboUsarioResponsavel.vue?vue&type=script&lang=ts"
export * from "./ComboUsarioResponsavel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports